import { ROUTE_CONSTANTS } from '../../constants/RouteConstants';
// import { ROUTE_CONSTANTS_VERSION_0 } from '../../version-0/src/constants/RouteConstants';
// import { ROUTE_CONSTANTS as ROUTE_CONSTANTS_WORMHOLE_VERSION_0 } from '../../version-0/wormhole/src/constants/RouteConstants';
import { ROUTE_CONSTANTS as ROUTE_CONSTANTS_WORMHOLE_VERSION_2 } from '../../version-2/wormhole/src/constants/RouteConstants';

export class NavigateUserService {
  getRoute = (id: any = null): string | null => {
    const path = window.location.pathname;

    // Combine route constants from all versions if needed
    const allRoutes = [
      ...Object.values(ROUTE_CONSTANTS),
      // ...Object.values(ROUTE_CONSTANTS_VERSION_0),
      // ...Object.values(ROUTE_CONSTANTS_WORMHOLE_VERSION_0),
      ...Object.values(ROUTE_CONSTANTS_WORMHOLE_VERSION_2),

    ];

    // Check if the current path matches any of the available routes
    for (const route of allRoutes) {
      const routePattern = route.replace(':projectId', '[a-zA-Z0-9]+')?.replace(':canvasID', '[a-zA-Z0-9]+');
      const regex = new RegExp(`^${routePattern}$`);
      if (regex.test(path)) {
        return path;
      }
    }

    // If an ID is provided, use it to construct the HOME route with the project ID
    if (id == "a82c6c28f92fa17c461ef51ac59e64e5") {
      return ROUTE_CONSTANTS.HOME.replace(':projectId', id);
    }
    else if (id) {
      return ROUTE_CONSTANTS.HOME.replace(':projectId', id);
    }

    return ROUTE_CONSTANTS.HOME;
  };

  getDefaultRoute = (): string => {
    return ROUTE_CONSTANTS.HOME;
  };
}